import { appHttpRequest } from '../../../utils/AppHttpRequest';
import { IPurchasePoDetail } from './bmsBillPurchasePoType';

class PurchasePoService {
	async one(id: string) {
		const apiUrl = `/bcm/purchase/findById/${id}`;
		return await appHttpRequest.get<IPurchasePoDetail>(apiUrl);
	}
}

export const purchasePoService = new PurchasePoService();
